import "core-js/modules/es.array.push.js";
import moment from 'moment';
export default {
  data() {
    return {
      dateValue: [],
      defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
    };
  },
  methods: {
    range(start, end) {
      const result = [];
      for (let i = start; i <= end; i++) {
        result.push(i);
      }
      return result;
    },
    disabledTime(date, type) {
      if (type === 'end' && date && date.length) {
        let endYear = moment(date[1]).year();
        let endMonth = moment(date[1]).month();
        let endDay = moment(date[1]).day();
        let currentYear = moment().year();
        let currentMonth = moment().month();
        let currentDay = moment().day();
        let currentHours = moment().hours();
        let currentMinutes = moment().minutes();
        let currentSeconds = moment().seconds();
        if (endYear === currentYear && endMonth === currentMonth && endDay === currentDay) {
          return {
            disabledHours: () => this.range(currentHours + 1, 24),
            disabledMinutes: () => this.range(currentMinutes + 1, 60),
            disabledSeconds: () => this.range(currentSeconds + 1, 60)
          };
        }
      }
      return {
        disabledHours: () => [],
        disabledMinutes: () => [],
        disabledSeconds: () => []
      };
    },
    disabledDate(current) {
      return current && current > moment().endOf('day');
    },
    openChangeDate(status) {
      if (status) {
        this.dateValue = [];
      }
    },
    resetData() {
      this.dateValue = [];
    },
    onChangeTime(date) {
      if (date.length) {
        let startIsToday = moment(this.dateValue[0]).isSame(moment(), 'days') && moment(this.dateValue[0]).isAfter(moment());
        let endIsToday = moment(this.dateValue[1]).isSame(moment(), 'days') && moment(this.dateValue[1]).isAfter(moment());
        if (startIsToday || endIsToday) {
          if (startIsToday && endIsToday) {
            this.dateValue[0] = moment();
            this.dateValue[1] = moment();
          } else if (endIsToday) {
            this.dateValue[1] = moment();
          }
        }
      }
      this.$emit('change', this.dateValue);
    }
  }
};